import { useEffect, useState } from 'react'
import Form, {
  Input,
  Select,
  Textarea
} from '../../../../../../components/Form'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../../../../../hooks/toast'
import { useLoading } from '../../../../../../hooks/loading'
import { apiCreate, apiDishesTypesOptions, apiUpdate } from '../../domain/api'
import { nameActions } from '../../domain/info'
import { FormContainer } from './styles'
import api from 'services/api'
import currency from 'currency.js'
import { genericMaskWithTwoZero } from 'utlis/mask'
import { v4 } from 'uuid'
import { Alert } from 'components/Alert'
import Modal from 'components/Modal'
import { FormAddIngredient } from '../FormAddIngredient'
import { FormAddDishComposiiton } from '../FormAddDishComposition'

const BRL = (value: string) =>
  currency(value, {
    decimal: ',',
    symbol: ''
  })

type INutritionalInformation = {
  id: string
  description: string
  quantity: string
  daily_percentage: string
}

type TypesFormProps = {
  initialValues?: IDishData & {
    idUpdate: number
  }
  typeForm: 'create' | 'update'
}

const nutritionalInformationsCategories = [
  'Energia',
  'Carboidratos',
  'Proteínas',
  'Gorduras totais',
  'Gorduras saturadas',
  'Gordutas trans',
  'Fibras alimentares',
  'Sódio'
]

export const FormDish = ({
  initialValues,
  typeForm
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()

  const [defaultValues, setDefaultValues] = useState<IDishData>()
  const [dishesTypes, setDishesTypes] = useState<IDishType[]>([])
  const [dishType, setDishType] = useState<number>()
  const [unitMeasure, setUnitMeasure] = useState<INGREDIENT_TYPES>()
  const [measure, setMeasure] = useState<string>('')
  const [profitInput, setProfit] = useState<string>()
  const [portionInput, setPortion] = useState<string>()
  const [nutritionalInformations, setNutritionalInformations] = useState<
    INutritionalInformation[]
  >([])

  const [dishesIngredients, setDishesIngredients] = useState<IDishIngredient[]>(
    []
  )

  const [modalAddIngredients, setModalAddIngredients] = useState({
    open: false,
    dish_id: 0
  })

  const [dishesCompositions, setDishesCompositions] = useState<
    IDishComposition[]
  >([])

  const [modalAddDishComposition, setModalAddDishComposition] = useState({
    open: false,
    dish_id: 0
  })

  const [modalEditIngredients, setModalEditIngredients] = useState<{
    open: boolean
    dishIngredient?: IDishIngredient
  }>({
    open: false
  })
  const handleClickOnOpenModalAddIngredient = (id: number) => {
    setModalAddIngredients({
      open: true,
      dish_id: id
    })
  }
  const handleClickOnCloseModalAddIngredient = () => {
    setModalAddIngredients({
      open: false,
      dish_id: 0
    })
  }

  const handleClickOnAddIngredient = (dishIngredient: IDishIngredient) => {
    setDishesIngredients(prev => [...prev, dishIngredient])
    setModalAddIngredients({
      open: false,
      dish_id: 0
    })
  }

  const handleClickOnEditIngredient = (dishIngredient: IDishIngredient) => {
    setDishesIngredients(prev => {
      const copy = JSON.parse(JSON.stringify(prev)) as IDishIngredient[]
      const index = copy.findIndex(
        item => item.ingredient_id === dishIngredient.ingredient_id
      )
      if (index !== -1) {
        copy[index] = dishIngredient
      }
      return copy
    })
    setModalEditIngredients({
      open: false
    })
  }

  const handleClickOnCloseModalEditIngredient = () => {
    setModalEditIngredients({
      open: false
    })
  }

  const [alertRemoveDishIngredient, setAlertRemoveDishIngredient] = useState({
    open: false,
    id: 0
  })

  const handlerOnClickButtonConfirmRemoveDishIngredient = async (
    id: number
  ) => {
    setDishesIngredients(prev => {
      const copy = JSON.parse(JSON.stringify(prev)) as IDishIngredient[]
      const index = copy.findIndex(item => item.id === id)
      if (index !== -1) {
        copy.splice(index, 1)
      }
      return copy
    })
    setAlertRemoveDishIngredient({
      open: false,
      id: 0
    })
  }

  const handlerOnClickButtonCancelRemoveDishIngredient = () => {
    setAlertRemoveDishIngredient({
      open: false,
      id: 0
    })
  }

  const handleClickOnOpenModalAddDishComposition = (id: number) => {
    setModalAddDishComposition({
      open: true,
      dish_id: id
    })
  }
  const handleClickOnCloseModalAddDishComposition = () => {
    setModalAddDishComposition({
      open: false,
      dish_id: 0
    })
  }

  const handleClickOnAddDishComposition = (
    dishComposition: IDishComposition
  ) => {
    setDishesCompositions(prev => [...prev, dishComposition])
    setModalAddDishComposition({
      open: false,
      dish_id: 0
    })
  }

  const [modalEditComposition, setModalEditComposition] = useState<{
    open: boolean
    dishComposition?: IDishComposition
  }>({
    open: false
  })

  const handleClickOnEditComposition = (dishComposition: IDishComposition) => {
    setDishesCompositions(prev => {
      const copy = JSON.parse(JSON.stringify(prev)) as IDishComposition[]
      const index = copy.findIndex(
        item => item.dish_id === dishComposition.dish_id
      )
      if (index !== -1) {
        copy[index] = dishComposition
      }
      return copy
    })
    setModalEditComposition({
      open: false
    })
  }

  const handleClickOnCloseModalEditComposition = () => {
    setModalEditComposition({
      open: false
    })
  }

  const [alertRemoveDishComposition, setAlertRemoveDishComposition] = useState({
    open: false,
    id: 0
  })

  const handlerOnClickButtonConfirmRemoveDishComposition = async (
    id: number
  ) => {
    setDishesCompositions(prev => {
      const copy = JSON.parse(JSON.stringify(prev)) as IDishComposition[]
      const index = copy.findIndex(item => item.id === id)
      if (index !== -1) {
        copy.splice(index, 1)
      }
      return copy
    })
    setAlertRemoveDishComposition({
      open: false,
      id: 0
    })
  }

  const handlerOnClickButtonCancelRemoveDishComposition = () => {
    setAlertRemoveDishComposition({
      open: false,
      id: 0
    })
  }

  const setNutritionalInformationField = (
    index: number,
    field: keyof INutritionalInformation,
    value: string
  ) => {
    nutritionalInformations[index][field] = value
    setNutritionalInformations([...nutritionalInformations])
  }

  const addNutritionalInformation = () => {
    setNutritionalInformations(prev => [
      ...prev,
      {
        id: v4(),
        daily_percentage: '',
        description: '',
        quantity: ''
      }
    ])
  }

  const removeNutritionalInformation = (index: number) => {
    const copy = [...nutritionalInformations]
    copy.splice(index, 1)
    setNutritionalInformations(copy)
  }

  useEffect(() => {
    api
      .get(apiDishesTypesOptions())
      .then(res =>
        setDishesTypes(
          res.data.sort((a: IDishType, b: IDishType) =>
            a.name.localeCompare(b.name)
          )
        )
      )
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro ao carregar os tipos de pratos',
          description:
            'Houve um erro ao carregar os tipos de pratos disponíveis no banco de dados.'
        })
      })
  }, [addToast])

  useEffect(() => {
    if (initialValues) {
      setDefaultValues({
        ...initialValues
      })

      if (initialValues.ingredients) {
        setDishesIngredients(prev => {
          const ingredients = initialValues.ingredients.filter(
            ingredient => ingredient.ingredient
          )
          return !prev.length ? ingredients : prev
        })
      }

      if (initialValues.compositions) {
        setDishesCompositions(prev => {
          const compositions = initialValues.compositions.filter(
            composition => composition.dishComposition
          )
          return !prev.length ? compositions : prev
        })
      }

      if (initialValues.profit) {
        setProfit(genericMaskWithTwoZero(initialValues.profit))
      }
      if (initialValues.portion) {
        setPortion(genericMaskWithTwoZero(initialValues.portion))
      }

      if (initialValues.measure) {
        if (['Pedaco', 'Unidade'].includes(initialValues.measure)) {
          setUnitMeasure('unit' as INGREDIENT_TYPES)
          setMeasure(initialValues.measure)
        }
        if (['Litro', 'Mililitro'].includes(initialValues.measure)) {
          setUnitMeasure('volume' as INGREDIENT_TYPES)
          setMeasure(initialValues.measure)
        }
        if (['Kilo', 'Grama', 'Miligrama'].includes(initialValues.measure)) {
          setUnitMeasure('weight' as INGREDIENT_TYPES)
          setMeasure(initialValues.measure)
        }
      }
    }
    if (initialValues?.nutritional_informations) {
      setNutritionalInformations(initialValues.nutritional_informations)
    } else {
      setNutritionalInformations(
        nutritionalInformationsCategories.map(item => ({
          id: v4(),
          daily_percentage: '',
          description: item,
          quantity: ''
        }))
      )
    }
  }, [initialValues])

  const { activeLoading, disableLoading } = useLoading()

  const onSubmitForm = async (data: IDishData) => {
    const id = initialValues?.idUpdate
    data.unit_measure = undefined

    const dishes_ingredients = dishesIngredients?.map(item => ({
      id: item.id,
      ingredient_id: item.ingredient_id,
      measure: item.measure,
      quantity: item.quantity,
      description: item.description,
      factor_cooking: item.factor_cooking
    }))

    const dishes_compositions = dishesCompositions?.map(item => ({
      id: item.id,
      dish_composition_id: item.dish_composition_id,
      quantity: item.quantity,
      measure: item.measure
    }))

    const profit = profitInput ? BRL(profitInput).value : 0
    const portion = portionInput ? BRL(portionInput).value : 0
    try {
      if (typeForm === 'create') {
        try {
          const dataCreate = {
            ...data,
            profit,
            portion,
            measure,
            nutritional_informations: nutritionalInformations.filter(
              item => item.description
            ),
            dishes_ingredients,
            dishes_compositions
          }

          activeLoading()
          await api.post(apiCreate(), dataCreate)
          disableLoading()
          addToast({
            type: 'success',
            title: 'Registro criado',
            description: 'Registro criado com sucesso'
          })
          history.push(nameActions.read.to)
        } catch (err: any) {
          addToast({
            type: 'error',
            title: 'Erro ao adicionar o registro',
            description:
              'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
          })
          disableLoading()
        }
      } else {
        const dataUpdate = {
          ...data,
          profit,
          portion,
          measure,
          nutritional_informations: nutritionalInformations.filter(
            item => item.description
          ),
          dishes_ingredients,
          dishes_compositions
        }
        try {
          activeLoading()
          const res = await api.put(apiUpdate(String(id)), dataUpdate)
          setDefaultValues(res.data)
          disableLoading()

          history.push(nameActions.read.to)
          addToast({
            type: 'success',
            title: 'Item atualizado',
            description: 'Item alterado com sucesso'
          })
        } catch (err: any) {
          addToast({
            type: 'error',
            title: 'Erro ao atualizar o item',
            description:
              'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
          })
        }
      }
      disableLoading()
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
      }
    }
  }

  return (
    <>
      <Form
        onSubmit={onSubmitForm}
        setReset
        defaultValues={{
          ...defaultValues
        }}
      >
        <>
          <div className="card mb-5 mb-xl-10">
            <FormContainer className="form-body">
              <div className="card-container">
                <h2 className="card-title">Sistema de receita</h2>
                <div className="row">
                  <Input
                    name="name"
                    className="col-md-4"
                    rules={{ required: true }}
                    label="Nome"
                  />
                  <Input
                    name="identifier"
                    className="col-md-4"
                    label="Identificador"
                  />
                  <Select
                    className=" col-md-2"
                    name="dish_type_id"
                    label="Tipo"
                    onChange={e => setDishType(+e.target.value)}
                    options={
                      typeForm === 'update'
                        ? dishesTypes.map(dish_type => {
                            return {
                              name: dish_type.name,
                              value: dish_type.id
                            }
                          })
                        : dishesTypes
                            .filter(dish_type => dish_type.is_active)
                            .map(dish_type => {
                              return {
                                name: dish_type.name,
                                value: dish_type.id
                              }
                            })
                    }
                    blank
                    value={dishType}
                    rules={{ required: true }}
                    errors={{ dish_type_id: !dishType }}
                    defaultValue={''}
                  />
                  {typeForm === 'update' && (
                    <Select
                      className=" col-md-2"
                      name="is_active"
                      label="Ativo"
                      options={[
                        {
                          name: 'Sim',
                          value: 'true'
                        },
                        {
                          name: 'Não',
                          value: 'false'
                        }
                      ]}
                      blank
                      defaultValue={'true'}
                      rules={{ required: true }}
                    />
                  )}
                  <Select
                    className="col-md-3"
                    name="show_in_ingredients_report"
                    label="Mostrar no relatório de ingredientes"
                    options={[
                      {
                        name: 'Sim',
                        value: 'true'
                      },
                      {
                        name: 'Não',
                        value: 'false'
                      }
                    ]}
                    blank
                    defaultValue={'true'}
                    rules={{ required: true }}
                  />
                </div>
                <div className="row">
                  <Input
                    name="profit"
                    className="col-md-2"
                    label="Rendimento"
                    price
                    onChange={e =>
                      setProfit(genericMaskWithTwoZero(e.target.value))
                    }
                    onKeyPress={event => {
                      const regex = /^[0-9.]+$/
                      if (!regex.test(event.key)) event.preventDefault()
                    }}
                  />
                  <Select
                    name="unit_measure"
                    label="Unidade de medida"
                    options={[
                      { name: 'Unidade', value: 'unit' },
                      { name: 'Volume', value: 'volume' },
                      { name: 'Peso', value: 'weight' }
                    ]}
                    blank
                    value={unitMeasure}
                    onChange={({ target }) => {
                      setUnitMeasure(target.value as INGREDIENT_TYPES)
                      setMeasure('')
                    }}
                    defaultValue={''}
                    className="col-md-4"
                    rules={{ required: true }}
                  />

                  {unitMeasure &&
                    ['weight', 'volume', 'unit'].includes(unitMeasure) && (
                      <Select
                        name="measure"
                        label="Medida"
                        options={
                          unitMeasure === 'weight'
                            ? [
                                { name: 'Kilo', value: 'Kilo' },
                                { name: 'Grama', value: 'Grama' },
                                { name: 'Miligrama', value: 'Miligrama' }
                              ]
                            : unitMeasure === 'volume'
                            ? [
                                { name: 'Litro', value: 'Litro' },
                                { name: 'Mililitro', value: 'Mililitro' }
                              ]
                            : unitMeasure === 'unit'
                            ? [
                                { name: 'Pedaco', value: 'Pedaco' },
                                { name: 'Unidade', value: 'Unidade' }
                              ]
                            : []
                        }
                        blank
                        value={measure}
                        onChange={({ target }) => setMeasure(target.value)}
                        defaultValue={''}
                        className="col-md-2"
                        rules={{ required: true }}
                      />
                    )}

                  <Input
                    name="portion"
                    className="col-md-2"
                    label="Porção"
                    price
                    value={portionInput}
                    onChange={e =>
                      setPortion(genericMaskWithTwoZero(e.target.value))
                    }
                    onKeyPress={event => {
                      const regex = /^[0-9.]+$/
                      if (!regex.test(event.key)) event.preventDefault()
                    }}
                  />

                  <Select
                    name="highlight_symbol"
                    label="Símbolo"
                    options={[
                      { name: '⏺', value: '⏺' },
                      { name: '✷', value: '✷' },
                      { name: '◆', value: '◆' },
                      { name: '◼', value: '◼' },
                      { name: '♣', value: '♣' },
                      { name: '♥', value: '♥' },
                      { name: '★', value: '★' },
                      { name: '✖', value: '✖' },
                      { name: '✚', value: '✚' },
                      { name: '⬢', value: '⬢' },
                      { name: '⯅', value: '⯅' },
                      { name: '☂', value: '☂' }
                    ]}
                    blank
                    defaultValue={''}
                    className="col-md-2"
                  />
                </div>

                <div className="py-4">
                  <label className="col-form-label fw-bold fs-6">
                    Ingredientes
                  </label>
                  <div>
                    <div className="row">
                      <div className="col-md-2">
                        <p className="fw-bold mb-4">Nome</p>
                      </div>
                      <div className="col-md-1 text-center">
                        <p className="fw-bold mb-4">Medida</p>
                      </div>
                      <div className="col-md-1 text-center">
                        <p className="fw-bold mb-4">Quantidade</p>
                      </div>
                      <div className="col-md-1 text-center">
                        <p className="fw-bold mb-4">Fator cocção</p>
                      </div>
                      <div className="col-md-2 text-center">
                        <p className="fw-bold mb-4">Ações</p>
                      </div>
                    </div>
                    {dishesIngredients?.map(dishIngredient => (
                      <div key={dishIngredient.id} className="row">
                        <div className="col-md-2 mt-3">
                          {dishIngredient.ingredient?.name}
                        </div>
                        <div className="col-md-1 text-center mt-3">
                          {dishIngredient.measure}
                        </div>
                        <div className="col-md-1 text-center mt-3">
                          {genericMaskWithTwoZero(dishIngredient.quantity)}
                        </div>
                        <div className="col-md-1 text-center mt-3">
                          {dishIngredient.factor_cooking
                            ? genericMaskWithTwoZero(
                                dishIngredient.factor_cooking
                              )
                            : '-'}
                        </div>
                        <div className="col-md-2 text-center mt-3">
                          <button
                            type="button"
                            className="btn btn-warning btn-sm mx-4"
                            onClick={() => {
                              setModalEditIngredients({
                                open: true,
                                dishIngredient
                              })
                            }}
                          >
                            Editar
                          </button>
                          <button
                            type="button"
                            className="btn btn-warning btn-sm"
                            onClick={() => {
                              setAlertRemoveDishIngredient({
                                open: true,
                                id: Number(dishIngredient.id)
                              })
                            }}
                          >
                            Remover
                          </button>
                        </div>
                      </div>
                    ))}
                    <div className="row">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm my-3 col-md-2"
                        onClick={() => {
                          handleClickOnOpenModalAddIngredient(
                            initialValues?.idUpdate
                          )
                        }}
                      >
                        + Adicionar ingrediente
                      </button>
                    </div>
                  </div>
                </div>

                <div className="py-4">
                  <label className="col-form-label fw-bold fs-6">
                    Composição
                  </label>
                  <div>
                    <div className="row">
                      <div className="col-md-2">
                        <p className="fw-bold mb-4">Nome</p>
                      </div>
                      <div className="col-md-1 text-center">
                        <p className="fw-bold mb-4">Medida</p>
                      </div>
                      <div className="col-md-1 text-center">
                        <p className="fw-bold mb-4">Quantidade</p>
                      </div>
                      <div className="col-md-2 text-center">
                        <p className="fw-bold mb-4">Ações</p>
                      </div>
                    </div>
                    {dishesCompositions?.map(dishComposition => (
                      <div key={dishComposition.id} className="row">
                        <div className="col-md-2 mt-3">
                          {dishComposition.dishComposition?.name}
                        </div>
                        <div className="col-md-1 text-center mt-3">
                          {dishComposition.measure}
                        </div>
                        <div className="col-md-1 text-center mt-3">
                          {dishComposition.quantity}
                        </div>
                        <div className="col-md-2 text-center mt-3">
                          <button
                            type="button"
                            className="btn btn-warning btn-sm"
                            onClick={() => {
                              setAlertRemoveDishComposition({
                                open: true,
                                id: Number(dishComposition.id)
                              })
                            }}
                          >
                            Remover
                          </button>
                        </div>
                      </div>
                    ))}
                    <div className="row">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm my-3 col-md-2"
                        onClick={() => {
                          handleClickOnOpenModalAddDishComposition(
                            initialValues?.idUpdate
                          )
                        }}
                      >
                        + Adicionar composição
                      </button>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="row">
                    <Textarea
                      name="description"
                      className=" col-md-12"
                      label="Observações da receita"
                      style={{ minHeight: 120 }}
                      defaultValue=""
                      rules={{ required: true, position: 'left' }}
                    />
                  </div>
                </div>
              </div>
              <div className="card-container">
                <h3 className="card-title">Área do cliente</h3>
                <div className="row">
                  <Textarea
                    name="client_description"
                    style={{ minHeight: 80 }}
                    defaultValue=""
                    className="col-md-6"
                    label="Descrição"
                  />

                  <Textarea
                    name="client_ingredients"
                    style={{ minHeight: 80 }}
                    defaultValue=""
                    className="col-md-6"
                    label="Ingredientes (breve descrição)"
                  />
                </div>
                <div className="row mt-4">
                  <label className="col-form-label fw-bold fs-6">
                    Informações nutricionais
                  </label>
                  <div className="row">
                    <Input
                      name="nutritional_informations_portion"
                      className="col-md-2"
                      label="Porção"
                    />
                  </div>
                  <div className="col-md-2 fs-6form-label fw-bold fs-6 mb-2">
                    Descrição
                  </div>
                  <div className="col-md-2 fs-6form-label fw-bold fs-6 mb-2">
                    Quantidade
                  </div>
                  <div className="col-md-2 fs-6form-label fw-bold fs-6 mb-2">
                    Porcentagem diária
                  </div>
                  {nutritionalInformations.map((item, index) => (
                    <div key={item.id} className="row">
                      <Input
                        name={`nutritional_informations.${item.id}.description`}
                        className="col-md-2"
                        value={item.description}
                        onChange={e => {
                          setNutritionalInformationField(
                            index,
                            'description',
                            e.target.value
                          )
                        }}
                        controlled
                      />
                      <Input
                        name={`nutritional_informations.${item.id}.quantity`}
                        className="col-md-2"
                        controlled
                        value={item.quantity}
                        onChange={e => {
                          setNutritionalInformationField(
                            index,
                            'quantity',
                            e.target.value
                          )
                        }}
                      />
                      <Input
                        name={`nutritional_informations.${item.id}.daily_percentage`}
                        className="col-md-2"
                        controlled
                        value={item.daily_percentage}
                        onChange={e => {
                          setNutritionalInformationField(
                            index,
                            'daily_percentage',
                            e.target.value
                          )
                        }}
                      />
                      <div className="col-md-1">
                        <button
                          type="button"
                          className="btn btn-warning btn-sm mt-1"
                          onClick={() => removeNutritionalInformation(index)}
                        >
                          Remover
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="row">
                  <button
                    type="button"
                    className="col-md-2 btn btn-primary btn-sm"
                    onClick={() => addNutritionalInformation()}
                  >
                    + Adicionar
                  </button>
                </div>
              </div>
            </FormContainer>
            <div className="card-footer d-flex justify-content-end py-6 px-9">
              <button type="submit" className="btn btn-primary">
                Salvar
              </button>
            </div>
          </div>
        </>
      </Form>
      <Alert
        message={'Tem certeza que deseja excluir o registro?'}
        onClickCancelButton={handlerOnClickButtonCancelRemoveDishIngredient}
        onClickConfirmButton={() =>
          handlerOnClickButtonConfirmRemoveDishIngredient(
            alertRemoveDishIngredient.id
          )
        }
        isActive={alertRemoveDishIngredient.open}
      />
      <Alert
        message={'Tem certeza que deseja excluir o registro?'}
        onClickCancelButton={handlerOnClickButtonCancelRemoveDishComposition}
        onClickConfirmButton={() =>
          handlerOnClickButtonConfirmRemoveDishComposition(
            alertRemoveDishComposition.id
          )
        }
        isActive={alertRemoveDishComposition.open}
      />
      {modalAddIngredients && (
        <Modal
          pageTitle={'Adicionar ingrediente'}
          onClickButtonCancel={handleClickOnCloseModalAddIngredient}
          isOpenModal={modalAddIngredients.open}
          style={{
            padding: '10px'
          }}
          Children={
            <>
              <FormAddIngredient
                handleClickOnAddIngredient={handleClickOnAddIngredient}
                typeForm="create"
                initialValues={{
                  dish_id: modalAddIngredients.dish_id
                }}
              />
            </>
          }
        />
      )}
      {modalAddDishComposition && (
        <Modal
          pageTitle={'Adicionar composição'}
          onClickButtonCancel={handleClickOnCloseModalAddDishComposition}
          isOpenModal={modalAddDishComposition.open}
          style={{
            padding: '10px',
            stylesModal: {
              minHeight: '600px',
              maxHeight: '80vh'
            }
          }}
          Children={
            <>
              <FormAddDishComposiiton
                handleClickOnAddDishComposition={
                  handleClickOnAddDishComposition
                }
                typeForm="create"
                initialValues={{
                  dish_id: initialValues?.idUpdate
                }}
              />
            </>
          }
        />
      )}
      {modalEditIngredients && (
        <Modal
          pageTitle={'Editar ingrediente'}
          onClickButtonCancel={handleClickOnCloseModalEditIngredient}
          isOpenModal={modalEditIngredients.open}
          style={{
            padding: '10px'
          }}
          Children={
            <>
              <FormAddIngredient
                handleClickOnEditIngredient={handleClickOnEditIngredient}
                typeForm="update"
                initialValues={{
                  dish_id: initialValues?.idUpdate,
                  dish_ingredient: modalEditIngredients.dishIngredient
                }}
              />
            </>
          }
        />
      )}
      {modalEditComposition && (
        <Modal
          pageTitle={'Editar composição'}
          onClickButtonCancel={handleClickOnCloseModalEditComposition}
          isOpenModal={modalEditComposition.open}
          style={{
            padding: '10px'
          }}
          Children={
            <>
              <FormAddDishComposiiton
                handleClickOnAddDishComposition={handleClickOnEditComposition}
                typeForm="update"
                initialValues={{
                  dish_id: initialValues?.idUpdate,
                  dish_composition: modalEditComposition.dishComposition
                }}
              />
            </>
          }
        />
      )}
    </>
  )
}
